import React from "react";

import { VerificationStatus } from "models";

import { Icon } from "components";

export const VerificationStatusDisplay = ({ status }: { status: VerificationStatus }) => {
  const map = {
    rejected: { icon: "tabler/circle-x", className: "paragraph-m rejected", label: "rejected" },
    pending: { icon: "tabler/help", className: "paragraph-m", label: "pending" },
    approved: { icon: "tabler/circle-check", className: "paragraph-m approved", label: "approved" },
    "auto-approved": { icon: "tabler/circle-check", className: "paragraph-m approved", label: "auto-approved" },
  };

  if (!status) {
    return <span className="paragraph-xs">No verification status</span>;
  }

  const { icon, className, label } = map[status];

  return (
    <span className={className}>
      <Icon iconName={icon} size="s" className="icon inline margin-right-25" />
      {label}
    </span>
  );
};
